import { connect } from 'react-redux';
import { getShowChapsDailyLimitModal, getChapsDailyLimitModalDates } from '../../../states/chaps/selectors';
import { resetApp } from '../../../states/page/actions';
import { PaymentLimits } from '../../../fasterPayments/components/Payments/PaymentLimitsModal';
import { resetChapsDailyLimitAuthorisation } from '../../../states/chaps/resetChapsDailyLimitAuthorisation';

const mapState = (state) => ({
	show: getShowChapsDailyLimitModal(state),
	dateList: getChapsDailyLimitModalDates(state),
});

const mapDispatch = (dispatch) => ({
	onCancel: () => dispatch(resetApp),
	onClose: () => dispatch(resetChapsDailyLimitAuthorisation()),
});

export const ChapsPaymentLimitsModal = connect(mapState, mapDispatch)(PaymentLimits);
